import { createApi } from './axios'
import { baseURL } from './config'

function handleResponse (res) {
  // if (!res.data.bool) throw new Error('Has an error!')
  return res.data
}

export default createApi(handleResponse, {
  getBindPhone () {
    return {
      url: '/api/v1/auth/get_bind_phone',
      method: 'GET',
      baseURL
    }
  },
  getPhoneCode ({ phone }) {
    return {
      url: '/api/v1/auth/alloc_code',
      method: 'GET',
      params: {
        phone
      },
      baseURL
    }
  },
  verifyPhoneCode ({ phone, code }) {
    return {
      url: '/api/v1/auth/verify_code',
      method: 'post',
      data: {
        phone,
        code
      },
      baseURL
    }
  }
})
